// extracted by mini-css-extract-plugin
export var smRow = "country-module--smRow--exlGB";
export var heading = "country-module--heading--1lkKa";